import { useArchiveTaskType } from '../../api/archiveTaskType';
import { useRestoreTaskType } from '../../api/restoreTaskType';
import { ArchiveToggle } from '../ArchiveToggle';

type Props = {
  _id: string;
  isArchived: boolean;
};

export const TaskTypeAction = ({ _id, isArchived }: Props) => {
  const archive = useArchiveTaskType();
  const restore = useRestoreTaskType();

  return (
    <ArchiveToggle
      isArchived={isArchived}
      isLoading={isArchived ? restore.isLoading : archive.isLoading}
      onArchive={() => archive.mutate({ _id })}
      onRestore={() => restore.mutate({ _id })}
    />
  );
};
